import React from 'react';
import { Link } from 'react-router-dom';
import { FaCamera, FaUsers, FaSearchPlus, FaChartLine } from 'react-icons/fa';

function LandingPage({ user }) {
  return (
    <div className="landing-page">
      <div className="landing-hero">
        <h1>PhotoMatch</h1>
        <p>Plateforme de découverte de photos propulsée par l'IA</p>
        <p>Retrouvez-vous automatiquement dans les photos d'événements grâce à la reconnaissance faciale</p>
        
        {!user && (
          <div className="hero-buttons">
            <Link to="/register" className="btn-primary">
              Commencer gratuitement
            </Link>
            <Link to="/login" className="btn-secondary">
              Se connecter
            </Link>
          </div>
        )}
        
        {user && (
          <div className="hero-buttons">
            <Link to="/dashboard" className="btn-primary">
              Aller au tableau de bord
            </Link>
          </div>
        )}
      </div>

      <div className="features-section">
        <h2>Comment fonctionne PhotoMatch</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <FaUsers />
            </div>
            <h3>1. Importez votre photo</h3>
            <p>
              Créez votre profil et importez une photo nette de vous.
              Notre IA apprend vos traits pour effectuer des correspondances précises.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaCamera />
            </div>
            <h3>2. Les photographes importent les événements</h3>
            <p>
              Les photographes professionnels créent des événements (mariages, anniversaires, entreprises)
              et importent les photos des clients sur la plateforme.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaSearchPlus />
            </div>
            <h3>3. L'IA trouve vos photos</h3>
            <p>
              Notre technologie de reconnaissance faciale vous associe automatiquement
              aux photos où vous apparaissez dans tous les événements.
            </p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <FaChartLine />
            </div>
            <h3>4. Consultez et analysez</h3>
            <p>
              Parcourez vos photos trouvées par événement, consultez les scores de confiance
              et suivez vos découvertes au fil du temps.
            </p>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>Idéal pour</h2>
        
        <div className="features-grid">
          <div className="feature-card">
            <h3>🎉 Event Attendees</h3>
            <p>
              Ne manquez plus aucune photo de vous lors de mariages, fêtes ou événements d'entreprise.
              PhotoMatch retrouve toutes vos photos automatiquement.
            </p>
          </div>

          <div className="feature-card">
            <h3>📷 Professional Photographers</h3>
            <p>
              Simplifiez la livraison des photos aux clients. Importez les photos d'un événement une seule fois
              et laissez les clients retrouver les leurs automatiquement.
            </p>
          </div>

          <div className="feature-card">
            <h3>🏢 Event Organizers</h3>
            <p>
              Améliorez l'expérience des participants en permettant à chacun de retrouver
              et consulter ses photos au même endroit.
            </p>
          </div>
        </div>
      </div>

      <div className="features-section" style={{ textAlign: 'center', padding: '3rem 2rem' }}>
        <h2>Prêt à commencer ?</h2>
        <p style={{ fontSize: '1.2rem', color: '#64748B', marginBottom: '2rem' }}>
          Rejoignez PhotoMatch dès aujourd'hui et ne manquez plus jamais une photo de vous !
        </p>
        {!user && (
          <Link to="/register" className="btn-primary" style={{ fontSize: '1.2rem', padding: '1.2rem 2.5rem' }}>
            Créer un compte gratuit
          </Link>
        )}
      </div>
    </div>
  );
}

export default LandingPage;
